// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backdrop__Txa5X {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.backdrop--disable-portal__y4LPN {
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/components/backdrop/backdrop.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,OAAA;EACA,oCAAA;AACJ;AACI;EACI,kBAAA;AACR","sourcesContent":[".backdrop {\n    position: fixed;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n\n    &--disable-portal {\n        position: absolute;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `backdrop__Txa5X`,
	"backdrop--disable-portal": `backdrop--disable-portal__y4LPN`
};
export default ___CSS_LOADER_EXPORT___;
